"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "boville-ernica": {
    "f90cc787": [{
      "hkey": "a51d5428",
      "slug": "antica-colle-piscioso",
      "name": "Antica Colle Piscioso",
      "primary": true,
      "skipSearch": false
    }],
    "colle-piscioso": [{
      "hkey": "a51d5428",
      "slug": "antica-colle-piscioso",
      "name": "Antica Colle Piscioso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "14f2a26b": [{
      "hkey": "bc6cc57e",
      "slug": "brecciaro-san-lucio",
      "name": "Brecciaro-San Lucio",
      "primary": true,
      "skipSearch": false
    }],
    "san-lucio": [{
      "hkey": "bc6cc57e",
      "slug": "brecciaro-san-lucio",
      "name": "Brecciaro-San Lucio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8f2d7175": [{
      "hkey": "3ea65d2d",
      "slug": "rotabile-santa-liberata",
      "name": "Rotabile-Santa Liberata",
      "primary": true,
      "skipSearch": false
    }],
    "santa-liberata": [{
      "hkey": "3ea65d2d",
      "slug": "rotabile-santa-liberata",
      "name": "Rotabile-Santa Liberata",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "d3dbc2c1": [{
      "hkey": "d0717d1a",
      "slug": "colle-campano-scrima",
      "name": "Colle Campano-Scrima",
      "primary": true,
      "skipSearch": false
    }],
    "scrima": [{
      "hkey": "d0717d1a",
      "slug": "colle-campano-scrima",
      "name": "Colle Campano-Scrima",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;